import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { TweenConstants } from "@lib/titan2-slingo/dist/game/view/abstract/constant/TweenConstants";
import { FullHouse } from "@lib/titan2-slingo/dist/game/view/abstract/display/FullHouse";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { TitanFancyTextFactory } from "../../../utils/FancyText/TitanFancyTextFactory";
import { GameSpineUtil } from "../../../utils/GameSpineUtil";
export class GameFullHouse extends FullHouse {
    create() {
        super.create();
        this.fireworkBurst = this.factory.createFireworkBurst();
        this.animation = TitanSpine.createSpine(this, this.landscapeProperties.animationProperties, this.portraitProperties?.animationProperties);
        this.title = TitanFancyTextFactory.CreateElement(this, this.langManager, this.landscapeProperties.titleProperties, this.portraitProperties?.titleProperties);
    }
    createMouseBlocker() {
        super.createMouseBlocker();
        this.mouseBlocker.onClick(() => this.skippableAnimation?.seek(this.skippableAnimation.duration(), false), this);
    }
    handleRotate(event) {
        super.handleRotate(event);
        GameSpineUtil.addToSlot(this.animation, this.fireworkBurst, "dynamic-fireworks");
        GameSpineUtil.addToSlot(this.animation, this.title, "dynamic-label-0");
    }
    reset() {
        super.reset();
        SpineUtil.reset(this.animation);
        this.visible = false;
    }
    async playAppear() {
        this.dispatchGame(SlingoEvent.FULL_HOUSE_APPEAR);
        this.mouseBlocker.interactiveChildren = false;
        this.fireworkBurst.start();
        this.showOverlay();
        SpineUtil.play(this.animation, "full-house");
        SpineUtil.playLoop(this.animation, "loop", 1);
        await gsap.fromTo(this.animation, { alpha: 0 }, { alpha: 1, duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION });
    }
    async playCelebrate() {
        this.skippableAnimation = gsap.to(this, { duration: 3 });
        this.mouseBlocker.interactiveChildren = true;
        await this.skippableAnimation;
        this.mouseBlocker.interactiveChildren = false;
        await gsap.to(this, { duration: 2.5 });
    }
    async playDisappear() {
        this.dispatchGame(SlingoEvent.FULL_HOUSE_DISAPPEAR);
        this.fireworkBurst.stop();
        this.hideOverlay();
        SpineUtil.play(this.animation, "full-house-out");
        await gsap.to(this.animation, { alpha: 0, duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION });
    }
    async handlePlayFullHouse() {
        this.visible = true;
        await this.playAppear();
        await this.playCelebrate();
        await this.playDisappear();
        this.handleAnimationComplete();
    }
}
//# sourceMappingURL=GameFullHouse.js.map